/** Angular Imports */
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

/** rxjs Imports */
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

/** Custom Services */
import { ClientsService } from '../clients.service';

/**
 * Client Accounts data resolver.
 */
@Injectable()
export class ClientAccountsResolver {
  private clientsService = inject(ClientsService);

  /**
   * Returns the Client Account data.
   * Falls back to empty data on error so the page still loads.
   * @returns {Observable<any>}
   */
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const clientId = route.parent.paramMap.get('clientId');
    return this.clientsService.getClientAccountData(clientId).pipe(
      catchError(() => of({ loanAccounts: [], savingsAccounts: [], shareAccounts: [] }))
    );
  }
}